import React from 'react';
import {withRouter} from 'react-router';
import {Form, Input, Radio, Button, message} from 'antd';
import LoadingCover from 'components/LoadingCover';
import abortAjaxHoc from 'components/abortAjaxHoc';
import {mixObjNotEmpty} from 'utils/tool';
import SubForm from 'components/SubForm';
import SceneFormItem from 'components/SceneFormItem';
import style from './OverseaCardForm.module.less';

const FormItem = SceneFormItem;
const thresholdRule = {
    required:true,
    pattern:/^(?:0(?:\.\d{1,3})?|1(?:\.0{1,3})?)$/,
    message:'Enter a number between 0 and 1, with up to three decimal places'
};

class OverseaCardForm extends React.Component {
    constructor(props){
        super(props);
        this.id = props.id;
        this.state = {loading:!!props.id,readOnly:false};
    }

    componentDidMount(){
        if(this.id){
            this.props.abortableAjax('GET', `/overseas_ocr_card_scene/${this.id}`).then(res=>{
                const readOnly = res.data.state === 'default';
                this.setNormalFields(res,()=>{
                    this.setNormalFields(res,()=>{
                        this.setState({
                            loading:false,
                            readOnly
                        });
                    });
                });
            }).catch(()=>this.setState({loading:false}));
        }
    }
    setDisabled = ()=>this.state.readOnly;

    setNormalFields = (res,callBack)=>{
        const {getFieldsValue,setFieldsValue} = this.props.form;
        const values = getFieldsValue();
        //取values存在的字段
        const newValues = mixObjNotEmpty(values,res.data);
        //表单回填
        setFieldsValue(newValues,()=>{
            callBack();
        });
    }

    save = ()=>this.props.form.validateFields(undefined,{ force:true},(errors, values)=>{
        if(errors) return;
        const params = {...values};
        this.setState({loading:true});
        const method = this.id ? 'POST' : 'PUT';
        const url = this.id ? `/overseas_ocr_card_scene/${this.id}` : '/overseas_ocr_card_scene';
        this.props.abortableAjax(method, url, params).then(()=>{
            message.success(this.id ? 'Updated successfully' : 'Created successfully');
            this.props.history.push('/pages/card-scenes');
        }).catch(()=>this.setState({loading:false}));
    })

    compareBrightness = (rule, value, callback)=>{
        const {threshold_min_brightness:min, threshold_max_brightness:max} = this.props.form.getFieldsValue();
        if(min !== undefined && max !== undefined && Number(min) >= Number(max)) callback('Minimum brightness must be less than maximum brightness');
        else callback();
    }

    thresholdItem(field, label, dec, initialValue='0.50', extraRules=[]){
        return <FormItem label={label} dec={dec}>
            {this.props.form.getFieldDecorator(field, {initialValue, rules:[thresholdRule, ...extraRules]})(
                <Input placeholder="Enter a number between 0 and 1" disabled={this.setDisabled()}/>
            )}
        </FormItem>;
    }

    renderCaptureTimeout = ()=>{
        const {getFieldValue, getFieldDecorator} = this.props.form;
        if(getFieldValue('threshold_capture_model') === '2'){
            return <SubForm>
                <FormItem label="Automatic-to-manual timeout" dec="Only applies to automatic-to-manual mode. Switches to manual capture after this time. Enter 3-30 seconds." style={{
                    marginBottom:0
                }}>
                    {getFieldDecorator('threshold_timeout', {
                        initialValue:'10',
                        rules:[
                            {required:true,message:'Enter the timeout'},
                            {pattern:/^(?:[3-9]|[12]\d|30)$/,message:'Enter an integer between 3 and 30'}
                        ]
                    })(
                        <Input style={{width:120}} disabled={this.setDisabled()}/>
                    )}
                    <span style={{marginLeft:8}}>seconds</span>
                </FormItem>
            </SubForm>;
        }
    }

    renderLightSpotThreshold = ()=>{
        const {getFieldValue, getFieldDecorator} = this.props.form;
        if(getFieldValue('light_spot_check_enabled') === 1){
            return <SubForm>
                <FormItem label="Light spot threshold" dec="Maximum light spot score allowed by light spot detection. Enter a value between 0 and 1." style={{
                    marginBottom:0
                }}>
                    {getFieldDecorator('threshold_light_spot_check', {
                        initialValue:'0.50',
                        rules:[thresholdRule]
                    })(
                        <Input placeholder="Enter a number between 0 and 1" disabled={this.setDisabled()}/>
                    )}
                </FormItem>
            </SubForm>;
        }
    }

    renderOcclusionThreshold = ()=>{
        const {getFieldValue, getFieldDecorator} = this.props.form;
        if(getFieldValue('occlusion_check_enabled') === 1){
            return <SubForm>
                <FormItem label="Occlusion threshold" dec="Maximum occlusion score allowed by occlusion detection. Enter a value between 0 and 1." style={{
                    marginBottom:0
                }}>
                    {getFieldDecorator('threshold_occlusion_check', {
                        initialValue:'0.50',
                        rules:[thresholdRule]
                    })(
                        <Input placeholder="Enter a number between 0 and 1" disabled={this.setDisabled()}/>
                    )}
                </FormItem>
            </SubForm>;
        }
    }

    formItemLayout = {
        labelCol: { span: 3 },
        wrapperCol: { span: 14 }
    };

    render(){
        const {getFieldDecorator} = this.props.form;
        return (
            <LoadingCover spinning={this.state.loading}>
                <Form layout="vertical">
                    <h1 className={`${style.section} ${style.first}`}>Basic Information</h1>
                    {this.id && <FormItem label="Scene ID" dec="Generated by the system after saving. It cannot be edited and must be passed when the client server obtains a token." {...this.formItemLayout}>
                        {getFieldDecorator('scene_id')(
                            <Input disabled/>
                        )}
                    </FormItem>}
                    <FormItem colon={false} label="Scene Name" {...this.formItemLayout}>
                        {getFieldDecorator('name', {
                            rules:[
                                {required:true,message:'This field is required'},
                                {min:1,max:20,message:'Enter 1-20 characters'}
                            ]
                        })(
                            <Input placeholder="Up to 20 characters" disabled={this.setDisabled()}/>
                        )}
                    </FormItem>
                    <FormItem colon={false} label="Scene Description" {...this.formItemLayout}>
                        {getFieldDecorator('description', {
                            rules:[
                                {max:128,message:'Enter no more than 128 characters'}
                            ]
                        })(
                            <Input placeholder="Up to 128 characters" disabled={this.setDisabled()}/>
                        )}
                    </FormItem>
                    <div className={style.line}></div>
                    <h1 className={style.section}>Capture Configuration</h1>
                    <FormItem label="Capture Mode">
                        {getFieldDecorator('threshold_capture_model', {
                            initialValue:'0',
                            rules:[
                                {required:true}
                            ]
                        })(
                            <Radio.Group disabled={this.setDisabled()}>
                                <Radio value="0">Automatic capture</Radio>
                                <Radio value="1">Manual capture</Radio>
                                <Radio value="2">Automatic to manual</Radio>
                            </Radio.Group>
                        )}
                    </FormItem>
                    {this.renderCaptureTimeout()}
                    <div className={style.line}></div>
                    <h1 className={style.section}>Image Quality Configuration</h1>
                    {this.thresholdItem('threshold_is_target_card','Confidence threshold','Controls whether the image is recognized as the target card. Enter a value between 0 and 1.')}
                    {this.thresholdItem('threshold_in_bound','Border alignment threshold','Controls whether the card is inside the guide frame and aligned with its borders. Enter a value between 0 and 1.')}
                    {this.thresholdItem('threshold_blur','Blur threshold','Controls the image sharpness requirement for the card. Enter a value between 0 and 1.')}
                    {this.thresholdItem('threshold_min_brightness','Minimum brightness','Rejects scenes that are too dark. Enter a value between 0 and 1; it must be less than the maximum brightness.','0.12',[{validator:this.compareBrightness}])}
                    {this.thresholdItem('threshold_max_brightness','Maximum brightness','Rejects scenes that are too bright. Enter a value between 0 and 1; it must be greater than the minimum brightness.','0.86',[{validator:this.compareBrightness}])}
                    <FormItem label="Light spot detection" dec="Controls whether light spot detection is enabled. Configure the light spot threshold when enabled.">
                        {getFieldDecorator('light_spot_check_enabled', {
                            initialValue:1,
                            rules:[
                                {required:true}
                            ]
                        })(
                            <Radio.Group disabled={this.setDisabled()}>
                                <Radio value={1}>Enabled</Radio>
                                <Radio value={0}>Disabled</Radio>
                            </Radio.Group>
                        )}
                    </FormItem>
                    {this.renderLightSpotThreshold()}
                    <FormItem label="Occlusion detection" dec="Controls whether occlusion detection is enabled. Configure the occlusion threshold when enabled.">
                        {getFieldDecorator('occlusion_check_enabled', {
                            initialValue:1,
                            rules:[
                                {required:true}
                            ]
                        })(
                            <Radio.Group disabled={this.setDisabled()}>
                                <Radio value={1}>Enabled</Radio>
                                <Radio value={0}>Disabled</Radio>
                            </Radio.Group>
                        )}
                    </FormItem>
                    {this.renderOcclusionThreshold()}
                </Form>
                <div className={style.actions}>
                    {!this.state.readOnly && (
                        <Button type="primary" onClick={this.save} loading={this.state.loading} style={{marginRight:24}}>
                            Save
                        </Button>
                    )}
                    <Button onClick={()=>this.props.history.push('/pages/card-scenes')}>Cancel</Button>
                </div>
            </LoadingCover>
        );
    }
}

export default Form.create()(abortAjaxHoc(withRouter(OverseaCardForm)));



// WEBPACK FOOTER //
// ./src/pages/OverseaCard/OverseaCardForm.js